import { render, staticRenderFns } from "./CompanyDepartmentsTable.vue?vue&type=template&id=4d78a732&scoped=true"
import script from "./CompanyDepartmentsTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompanyDepartmentsTable.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CompanyDepartmentsTable.vue?vue&type=style&index=0&id=4d78a732&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d78a732",
  null
  
)

export default component.exports